// extracted by mini-css-extract-plugin
export default {"isBcmsSyncedIcon":"styles_isBcmsSyncedIcon__-njR1","tooltip":"styles_tooltip__pJDnF","tooltipPopper":"styles_tooltipPopper__8IP6m","spin":"styles_spin__1eR+L"};